export const ACQUIRER = {
    MERCADO_PAGO: {value: 1},
    PAGSEGURO: {value: 2}
}